import styled from "styled-components";

import FallbackImage from "components/global/FallbackImage";

export const SchoolTeamsSectionInfoRow = styled.div.attrs({
  className: "flex items-center gap-3",
})``;

export const SchoolTeamsSectionSection = styled.div.attrs({ className: "h-12 w-12 shrink-0" })``;

export const SchoolTeamsSectionThumbnailImage = styled(FallbackImage).attrs({
  className: "h-12 w-12 rounded-2xl",
})``;

export const SchoolTeamsSectionLabelText = styled.p.attrs({
  className: "font-medium text-[var(--brand-ink)]",
})``;

export const SchoolTeamsSectionMetaText = styled.p.attrs({
  className: "text-xs text-[var(--brand-muted)]",
})``;

export const SchoolTeamsSectionGridLayout = styled.div.attrs({ className: "grid gap-6" })``;

export const SchoolTeamsSectionGridLayoutSecondary = styled.div.attrs({
  className: "grid gap-4",
})``;

export const SchoolTeamsSectionInfoRowSecondary = styled.div.attrs({
  className: "flex items-center gap-4",
})``;

export const SchoolTeamsSectionSectionSecondary = styled.div.attrs({
  className: "h-16 w-16 shrink-0",
})``;

export const SchoolTeamsSectionPreviewImage = styled(FallbackImage).attrs({
  className: "h-16 w-16 rounded-[22px] border border-[var(--brand-border)] bg-[rgba(255,255,255,0.04)] shadow-[0_12px_20px_rgba(0,0,0,0.18)]",
})``;

export const SchoolTeamsSectionTextGroup = styled.div.attrs({ className: "min-w-0" })``;

export const SchoolTeamsSectionEyebrowText = styled.p.attrs({
  className: "font-anonymous text-xs uppercase tracking-[0.22em] text-[var(--brand-highlight)]",
})``;

export const SchoolTeamsSectionTitleHeading = styled.h3.attrs({
  className: "mt-2 text-lg font-semibold text-[var(--brand-ink)]",
})``;

export const SchoolTeamsSectionMetaTextSecondary = styled.p.attrs({
  className: "mt-1 text-sm text-[var(--brand-muted)]",
})``;

export const SchoolTeamsSectionGridLayoutTertiary = styled.div.attrs({
  className: "grid gap-4 md:grid-cols-2",
})``;

export const SchoolTeamsSectionSectionTertiary = styled.div.attrs({
  className: "brand-panel-muted",
})``;

export const SchoolTeamsSectionEyebrowTextSecondary = styled.p.attrs({
  className: "text-xs uppercase tracking-[0.2em] text-[var(--brand-muted)]",
})``;

export const SchoolTeamsSectionTitleText = styled.p.attrs({
  className: "mt-2 text-lg font-medium text-[var(--brand-ink)]",
})``;

export const SchoolTeamsSectionLabelTextSecondary = styled.p.attrs({
  className: "mt-2 text-sm font-medium text-[var(--brand-ink)]",
})``;

export const SchoolTeamsSectionBodyText = styled.p.attrs({
  className: "text-xs leading-6 text-[var(--brand-muted)]",
})``;

export const SchoolTeamsSectionGridLayoutQuaternary = styled.div.attrs({
  className: "grid gap-6 xl:grid-cols-[0.95fr_1.05fr]",
})``;

